// Vendor Libraries

try {

  window.$ = window.jQuery = require('jquery');
  window.Selectric         = require('jquery-selectric');

  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode ? 'is-ie' : 'is-not-ie';
  $('html').removeClass('no-js').addClass('is-loaded').addClass(isIE11);

} catch (e) {
  console.log(e);
}

import { accordion } from './components/accordion';
import { slider } from './components/slider';
import { hero } from './blocks/hero';

jQuery(document).ready(function($) {

  // Components
  require('./components/utilities');
  require('./components/scrollTracker');
  require('./components/animation');
  require('./components/gsap');
  require('./components/ada');

  // Blocks
  require('./blocks/wp-menu');

  accordion();
  slider();
  hero();

});